export default __webpack_public_path__ + "static/media/syrie_stroke.53664b07.svg";